import UserFavorites from './UserFavorites';
export default UserFavorites;